import React from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  IconButton
} from '@mui/material';
import { IUploadModal } from './processingUploadModal.models';
import CloseIcon from '@mui/icons-material/Close';
import {
  buttonsStyles,
  cancelButtonStyles,
  closeIconStyles,
  containerStyles,
  continueButtonDisabledStyles,
  continueButtonStyles,
  modalStyles,
  progressBar1Styles,
  progressBar2DisableStyles,
  progressBar2Styles,
  progressStyles,
  titleStyles,
  uploadedFileNameStyles,
  uploadedFileSizeStyles
} from './processingUploadModal.styles';
import { MbConverter } from '../../../helpers/MbConverter';
import { removeLastExtension } from '../../../helpers/removeExtension';
import Progress from '../../../components/Progress';

const ProcessingUploadModal: React.FC<IUploadModal> = ({
  upDat,
  uploadedFileName,
  uploadedFileSize,
  setUploadStatus,
  uploadStatus,
  progress,
  setProgress,
  onContinue,
  open,
  onClose,
  processingInputData,
  uploadSucceeded
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        style: modalStyles
      }}
    >
      <div style={containerStyles}>
        <DialogTitle style={titleStyles}>
          Uploading Dataset
          <IconButton onClick={onClose} sx={closeIconStyles}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <div style={uploadedFileNameStyles}>
          {uploadedFileName && uploadedFileName.length > 0
            ? removeLastExtension(uploadedFileName)
            : removeLastExtension(processingInputData?.uploadedFileName)}
        </div>
        <div style={uploadedFileSizeStyles}>
          (
          {typeof uploadedFileSize === 'number'
            ? MbConverter(uploadedFileSize)
            : MbConverter(processingInputData.uploadedFileSize)}
          )
        </div>
        <DialogContent sx={progressStyles}>
          <DialogContentText>
            <Progress uploadStatus={uploadStatus} progress={progress} setPredictionProgress={setProgress} />
          </DialogContentText>
        </DialogContent>
        {upDat === undefined && (
          <DialogActions sx={buttonsStyles}>
            <Button variant="contained" style={cancelButtonStyles} onClick={onClose}>
              Cancel
            </Button>
            <Button
              variant="contained"
              style={progress === '100' ? continueButtonStyles : continueButtonDisabledStyles}
              onClick={onContinue}
              disabled={progress !== '100'}
            >
              Continue
            </Button>
          </DialogActions>
        )}
      </div>
    </Dialog>
  );
};

export default ProcessingUploadModal;
